module.exports = __webpack_public_path__ + "img/65.8.TSS.e18b2660.png";